import React from 'react'
import { List, ListItemButton, ListItemIcon, ListItemText, Popover } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Send } from '@mui/icons-material'

type ArchivedProjectActionsMenuProps = {
    anchorEl?: null | HTMLElement
    id?: string
    onClose: () => void
    onSendMailAction: (id: string) => void
}

export const ArchivedProjectActionsMenu: React.FC<ArchivedProjectActionsMenuProps> = ({
    anchorEl,
    onClose,
    onSendMailAction,
    id,
}) => {
    const { t } = useTranslation()

    return (
        <Popover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            anchorOrigin={{
                horizontal: 'left',
                vertical: 'bottom',
            }}
            onClose={onClose}
            PaperProps={{ sx: { minWidth: 200 } }}
        >
            <List sx={{ width: '100%' }}>
                <ListItemButton onClick={() => onSendMailAction(id!)}>
                    <ListItemIcon>
                        <Send />
                    </ListItemIcon>
                    <ListItemText primary={t('common.sendLinkToCustomers')} />
                </ListItemButton>
            </List>
        </Popover>
    )
}
